import { h } from 'preact';
import { getCopy } from 'utils/copy';
import * as BaseComp from 'components/bolt/header/sharePopout.js';
// import s from 'components/bolt/header/sharePopout.sss';

export default class SharePopout extends BaseComp.default {

	componentDidUpdate(prevProps) {
		const data = this.props?.appData?.header?.powsterHeader?.share || {};

		if (prevProps.shareCopy !== this.props.shareCopy) {
			this.shareCopy = this.props.shareCopy || getCopy(data.socialCopy, {}, '', null, 'baseCopy') || data.socialCopy;
		}
	}

}
